import { render, staticRenderFns } from "./QuizResults.vue?vue&type=template&id=b1b9c3bc"
import script from "./QuizResults.vue?vue&type=script&lang=js"
export * from "./QuizResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports